import { CircularProgress, IconButton } from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";
import "./QuiqIcon.scss";

interface QuiqIconProps {
  className?: string;
  children: Element | React.ReactNode;
  color?: "inherit" | "primary" | "secondary" | "default";
  onClick: (event?: React.MouseEvent<HTMLElement>) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  containerClassName?: string;
}

export const QuiqIcon: React.SFC<QuiqIconProps> = ({
  className,
  children,
  color,
  onClick,
  isLoading,
  isDisabled,
  containerClassName,
  ...otherProps
}) => (
  <div className={`QuiqIcon ${containerClassName}`}>
    <div className="QuiqIcon__container">
      <IconButton
        className={classnames("QuiqIcon__icon", {
          [`${className}`]: className
        })}
        children={children}
        color={color}
        onClick={onClick}
        disabled={isDisabled || isLoading}
        {...otherProps}
      />
    </div>

    {isLoading && (
      <div className="QuiqIcon__container">
        <CircularProgress size={24} className="QuiqIcon__spinner" />
      </div>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/shared/QuiqIcon.tsx